export const initialFormValues = {
  verificationCode: '',
} as const
